import {Box} from "@mui/material";
import styles from "./style.module.css";

export default function InternalVMware({focused, width = 50, height = 37, ...props}: any) {
    return (
        <Box position="relative" {...props}>
            <Box position="absolute" zIndex={1} className={styles[focused ? "rotateForward" : "rotateBackward"]}>
                <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 37 43">
                    <path fill="none" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4px"
                          d="M10.1,26.5l8.4,4.9,8.4-4.9v-9.8s-8.4-4.9-8.4-4.9l-8.4,4.9v9.8Z"/>
                </svg>
            </Box>
            <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 37 43">
                <path strokeWidth="0px" fill="#e1e2e4"
                      d="M36.9,11.1L18.6,1,.3,11.1l18.3,10.4,18.3-10.4Z"/>
                <path strokeWidth="0px" fill="#ce412e" d="M36.9,11.1v20.7l-18.3,10.5v-20.8l18.3-10.4Z"/>
                <path strokeWidth="0px" fill="#ee4d2f" d="M.3,11.1l18.3,10.4v20.8L.3,31.8V11.1Z"/>
            </svg>
        </Box>
    )
}